import { lazy } from "react";

//*Todas los screen que se crean deben ser export default function para funcionar con el lazy
//Screens
const HomeScreen = lazy(() => import("../../views/users/home/HomeScreen"));

//ADMINISTRADOR
const UserScreen = lazy(() => import("../../views/users/UserScreen"));

//TEACHERS
const TeacherScreen = lazy(() => import("../../views/teachers/TeacherScreen"));
const TeacherDetail = lazy(() => import("../../views/teachers/TeacherDetail"));
const TeacherTechnicalSheet = lazy(() =>
    import("../../views/teachers/TeacherTechnicalSheet")
);

//CUSTOMERS
const CustomerScreen = lazy(() =>
    import("../../views/customers/CustomerScreen")
);
const CustomerDetail = lazy(() =>
    import("../../views/customers/CustomerDetail")
);

//OPPORTUNITIES
const OpportunityScreen = lazy(() =>
    import("../../views/customers/opportunities/OpportunityScreen")
);
const OpportunityAdvancesScreen = lazy(() =>
    import("../../views/customers/opportunities/OpportunityAdvancesScreen")
);

//PORTFOLIOS
const PortfolioScreen = lazy(() =>
    import("../../views/customers/portfolios/PortfolioScreen")
);
const PortfolioDetailScreen = lazy(() =>
    import("../../views/customers/portfolios/PortfolioDetailScreen")
);

//teachers payroll v1
const PayrollScreen = lazy(() =>
    import("../../views/teachers/v1/payroll/PayrollScreen")
);
const TeacherPayroll = lazy(() =>
    import("../../views/teachers/v1/payroll/teacher/TeacherPayroll")
);
const TeacherPayrollDetail = lazy(() =>
    import("../../views/teachers/v1/payroll/teacher/TeacherPayrollDetail")
);

//teachers payroll v2
const CycleScreen = lazy(() =>
    import("../../views/operators/cycle/CycleScreen")
);
const CurriculaScreen = lazy(() =>
    import("../../views/operators/curriculums/CurriculaScreen")
);
const CurriculaEdit = lazy(() =>
    import("../../views/operators/curriculums/CurriculaEdit")
);
const SchoolSubjectScreen = lazy(() =>
    import("../../views/operators/school_subjects/SchoolSubjectScreen")
);
const CutsPayroll = lazy(() =>
    import("../../views/teachers/v2/payroll/CutsPayroll")
);
const TabulatorScreen = lazy(() =>
    import("../../views/teachers/v2/tabulators/TabulatorScreen")
);
const ModulesScreenTeacher = lazy(() =>
    import("../../views/teachers/v2/modules/ModulesScreen")
);
const TeacherPunch = lazy(() =>
    import("../../views/teachers/v2/payroll/punches/TeacherPunch")
);
const JustifyScreen = lazy(() =>
    import("../../views/teachers/v2/justify/JustifyScreen")
);
//Rutas de educacion a distancia
const EADScreen = lazy(() => import("../../views/teachers/EAD/EADScreen"));

//Fin rutas de educacion a distancia

//STUDENTS
const StudentsScreen = lazy(() =>
    import("../../views/students/StudentsScreen")
);
const StudentsScreenAdmission = lazy(() =>
    import("../../views/students/StudentsScreenAdmission")
);

// Encuestas
const SurveysScreen = lazy(() =>
    import("../../views/users/surveys/SurveysScreen")
);

// Exámenes
const ExamsScreen = lazy(() => import("../../views/users/exams/ExamsScreen"));

// Eventos académicos
const AcademicEventsScreen = lazy(() =>
    import("../../views/operators/academic_events/AcademicEventsScreen")
);

// Asistentes de eventos academicos
const AcademicEventsParticipants = lazy(() =>
    import("../../views/operators/academic_events/AcademicEventsParticipants")
);

// Aplicación de encuesta
const SurveyApplication = lazy(() =>
    import("../../views/users/surveys/SurveyApplication")
);

// Aplicación de examen
const ExamApplication = lazy(() =>
    import("../../views/users/exams/ExamApplication")
);

// Resultados de encuesta
const SurveyResultsScreen = lazy(() =>
    import("../../views/users/surveys/SurveyResultsScreen")
);

const StudentDetail = lazy(() =>
    import("../../views/students/StudentDetail/StudentDetail")
);
const GenerateXMLScreen = lazy(() =>
    import("../../views/students/GenerateXMLScreen")
);
const OperatorClarificationScreen = lazy(() =>
    import("../../views/students/Aclarations/OperatorClarificationScreen")
);

//PROFESSIONAL_PRACTICES
const ProfessionalPracticesScreen = lazy(() =>
    import(
        "../../views/students/plans_and_study_programs/ProfessionalPracticesScreen"
    )
);
const ProfessionalPracticesDetail = lazy(() =>
    import(
        "../../views/students/plans_and_study_programs/ProfessionalPracticesDetail"
    )
);
//SERVICE_SOCIAL
const SocialServiceScreen = lazy(() =>
    import("../../views/students/plans_and_study_programs/SocialServiceScreen")
);
//PARTNERSHIPS
const PartnershipsScreen = lazy(() =>
    import("../../views/students/Partnerships/Partnerships")
);

//EMPLOYEES
const EmployeeScreen = lazy(() =>
    import("../../views/employees/EmployeeScreen")
);
const EmployeeDetail = lazy(() =>
    import("../../views/employees/EmployeeDetail")
);
const EmployeeReport = lazy(() =>
    import("../../views/employees/report/TechnicalSheetEmployee")
);

const DepartmentScreen = lazy(() =>
    import("../../views/employees/departments/DepartmentScreen")
);
const PunchesScreen = lazy(() =>
    import("../../views/employees/Punches/PunchesScreen")
);
const AllPunchesScreen = lazy(() =>
    import("../../views/employees/Punches/AllPunchesScreen")
);
const SchedulesScreen = lazy(() =>
    import("../../views/employees/schedule/SchedulesScreen")
);

const SchedulesForm = lazy(() =>
    import("../../views/employees/schedule/SchedulesForm")
);

//MANUALS
const ManualsScreen = lazy(() =>
    import("../../views/employees/manuals/ManualsScreen")
);

const PublicManualScreen = lazy(() =>
    import("../../views/employees/manuals/PublicManualScreen")
);

//FORMATS
const FormatScreen = lazy(() =>
    import("../../views/employees/formats/FormartScreen")
);
const PublicFormatScreen = lazy(() =>
    import("../../views/employees/formats/PublicFormatScreen")
);

//CALENDAR
const CalendarScreen = lazy(() =>
    import("../../views/employees/incidents/calendar/CalendarScreen")
);
//MODULES
const ModulesScreen = lazy(() =>
    import("../../views/users/modules/ModulesScreen")
);
//ROLES
const RolesScreen = lazy(() => import("../../views/users/roles/RolesScreen"));
//CYCLE STUDENTS REPORT
const CycleStudentsReportScreen = lazy(() =>
    import(
        "../../views/operators/cycle_student_report/cycleStudentReportScreen"
    )
);
const StudentsByScheduleReportScreen = lazy(() =>
    import(
        "../../views/operators/students_by_schedule/StudentsByScheduleReportScreen"
    )
);
const LanguageFollowUpScreen = lazy(() =>
    import("../../views/operators/language_follow_up/LanguageFollowUpScreen")
);
//STUDENTS ATTENDANCES REPORT
const StudentsAttendancesReportScreen = lazy(() =>
    import(
        "../../views/operators/students_attendances_report/StudentsAttendancesReportScreen"
    )
);
//ATTENDANCES REPORT
const TeacherAttendancesReportScreen = lazy(() =>
    import(
        "../../views/operators/attendances_report/TeacherAttendancesReportScreen"
    )
);
//CLASS LOAD REPORT
const ClassLoadReportScreen = lazy(() =>
    import("../../views/operators/class_load_report/ClassLoadReportScreen")
);
//HOURS BY SUBJECT REPORT
const SubjectHoursReportScreen = lazy(() =>
    import(
        "../../views/operators/subject_hours_report/SubjectHoursReportScreen"
    )
);
//SUBJECTS AND PAYMENTS BY STUDENTS REPORT
const SubjectsAndPaymentsByStudentsScreen = lazy(() =>
    import(
        "../../views/operators/subjects_and_payments_by_students_report/SubjectsAndPaymentsByStudentsScreen"
    )
);
//CLASS SCHEDULES REPORT
const ClassSchedulesReportScreen = lazy(() =>
    import(
        "../../views/operators/class_schedules_report/ClassSchedulesReportScreen"
    )
);
//INCIDENTS
const IncidentsScreen = lazy(() =>
    import("../../views/employees/incidents/RH/IncidentsScreen")
);
const ReportPayrollScreen = lazy(() =>
    import("../../views/employees/incidents/reports/ReportPayrollScreen")
);
const IncidentLog = lazy(() =>
    import("../../views/employees/incidents/reports/IncidentLog")
);

//CORPORATIVE
const VacationScreen = lazy(() =>
    import("../../views/employees/corporative/VacationScreen")
);
//AREA_DIRECTOR
const AreaDirectorsScreen = lazy(() =>
    import("../../views/employees/incidents/area_directors/AreaDirectorsScreen")
);
//TICKETS
const TicketsScreen = lazy(() =>
    import("../../views/employees/support/TicketsScreen")
);
const WarehouseScreen = lazy(() =>
    import("../../views/employees/support/WarehouseScreen")
);
const TicketsByUser = lazy(() =>
    import("../../views/employees/support/TicketsByUser")
);
//set aside rooms
const EventScreen = lazy(() =>
    import("../../views/employees/events/EventScreen")
);

// Certificados
const ElectronicTitlesScreen = lazy(() =>
    import("../../views/students/electronic_titles/ElectronicTitlesScreen")
);

//Modulo compras
const ProviderScreen = lazy(() =>
    import("../../views/employees/shopping/providers/ProviderScreen")
);
const PurchaseScreen = lazy(() =>
    import("../../views/employees/shopping/purchases/PurchaseScreen")
);
const BudgetScreen = lazy(() =>
    import("../../views/employees/shopping/budgets/BudgetScreen")
);

//Perfil de usuario

const ProfileScreen = lazy(() =>
    import("../../views/employees/profile/ProfileScreen")
);

const GroupScreen = lazy(() =>
    import("../../views/teachers/v2/modules/groups/GroupScreen")
);

//Configuraciones intranet
const SettingScreen = lazy(() =>
    import("../../views/users/config/SettingScreen")
);

//Registrar nueva empresa - intranet
const EnterprisesScreen = lazy(() =>
    import("../../views/users/config/EnterprisesScreen")
);

//Configuraciones intranet
const OrganizationScreen = lazy(() =>
    import("../../views/employees/organization/OrganizationScreen")
);

//Rutas de grupos de estudiantes
const AcademicGroupsScreen = lazy(() =>
    import("../../views/operators/academic_groups/AcademicGroupsScreen")
);

// Horarios de diplomados
const DiplomaSchedulesScreen = lazy(() =>
    import(
        "../../views/operators/extracurricular_subjects/DiplomaSchedules/DiplomaSchedules"
    )
);
//Rutas de materias extracurriculares
const TesisAndUAIsSubjectsScreen = lazy(() =>
    import(
        "../../views/operators/extracurricular_subjects/TesisAndUAIsSubjects"
    )
);
const ExtracurricularSubjectsScreen = lazy(() =>
    import(
        "../../views/operators/extracurricular_subjects/ExtracurricularSubjects"
    )
);
// Rondines de verificación de asistencias
const AttendanceRoundsScreen = lazy(() =>
    import("../../views/operators/attendance_rounds/AttendanceRoundsScreen")
);

const AcademicGroupsEdit = lazy(() =>
    import("../../views/operators/academic_groups/AcademicGroupsEdit")
);
const EarlyInterventionScreen = lazy(() =>
    import("../../views/operators/early_interventions/EarlyInterventionScreen")
);

//Rutas de infraestructura
const BuildingScreen = lazy(() =>
    import("../../views/operators/Infrastructure/BuildingScreen")
);

const BuildingEdit = lazy(() =>
    import("../../views/operators/Infrastructure/BuildingEdit")
);

const ClassroomScreen = lazy(() =>
    import("../../views/operators/Infrastructure/ClassroomScreen")
);

const ClassroomEdit = lazy(() =>
    import("../../views/operators/Infrastructure/ClassroomEdit")
);
const CoordinationScreen = lazy(() =>
    import("../../views/operators/coordinations/CoordinationScreen")
);

//Curricula tabulators routes
const CurriculaTabulatorScreen = lazy(() =>
    import(
        "../../views/operators/curricula_tabulators/CurriculaTabulatorsScreen"
    )
);

const ScholarshipsScreen = lazy(() =>
    import("../../views/operators/Scholarships/ScholarshipScreen")
);

const MoodleBlocksScreen = lazy(() =>
    import("../../views/operators/moodle/moodle_blocks/MoodleBlocksScreen")
);

//RECEIVED PAYMENTS
const PaymentsScreen = lazy(() =>
    import("../../views/operators/payments/PaymentsScreen")
);

// Control de extraordinarios
const ExtraordinariesControlScreen = lazy(() =>
    import(
        "../../views/operators/extraordinaries_control/ExtraordinariesControlScreen"
    )
);

const StudentsReport = lazy(() =>
    import("../../views/students/report/StudentsReport")
);

const InscriptionSummaryScreen = lazy(() =>
    import("../../views/operators/inscriptionSummary/InscriptionSummaryScreen")
);

const ConventionScreen = lazy(() =>
    import("../../views/operators/conventions/ConventionScreen")
);

const PositiveBalanceScreen = lazy(() =>
    import("../../views/operators/positive_valance/PositiveBalanceScreen")
);

const OrphanInsuranceScreen = lazy(() =>
    import("../../views/operators/orphan_insurance/OrphanInsuranceScreen")
);

//school control reports
const SchoolControlReportsScreen = lazy(() =>
    import("../../views/operators/schoool_control/ReportsScreen")
);

//*school control reports
const GradeUploadReportScreen = lazy(() =>
    import("../../views/operators/grade_upload_report/GradeUploadReportScreen")
);

const TeachersByCycleReportScreen = lazy(() =>
    import(
        "../../views/operators/teachers_by_cycle/TeachersByCycleReportScreen"
    )
);

// Reporte de adeudos por mes
const DebtsByMonthReportsScreen = lazy(() =>
    import("../../views/operators/debts_by_month/DebtsByMonthReportsScreen")
);

// Reporte de becas
const ScholarshipsReportsScreen = lazy(() =>
    import(
        "../../views/operators/scholarships_report/ScholarshipsReportsScreen"
    )
);

// Reporte de calificaciones por materia
const GradesBySubjectScreen = lazy(() =>
    import("../../views/operators/grades_by_subject/GradesBySubjectScreen")
);

const GradesBySubjectReportScreen = lazy(() =>
    import(
        "../../views/operators/grade_by_subject_report/GradesBySubjectReportScreen"
    )
);

// Descargas de kardex
const DownloadKardexScreen = lazy(() =>
    import("../../views/operators/download_kardex/DownloadKardexScreen")
);

//GradesEditScreen
const GradesEditScreen = lazy(() =>
    import("../../views/operators/grades_edit/GradesEditScreen")
);

// Reporte de inscripciones por ciclo y carrera
const InscriptionsByCycleReportsScreen = lazy(() =>
    import(
        "../../views/operators/academic_record_by_curriculum/AcademicRecordByCurriculum"
    )
);

// Reporte de placas vehiculares
const VehiclePlatesReportsScreen = lazy(() =>
    import(
        "../../views/operators/vehicle_plates_report/VehiclePlatesReportsScreen"
    )
);

// Reporte de rendimiento de docentes
const TeachersPerformanceReportScreen = lazy(() =>
    import(
        "../../views/operators/teachers_performance_report/TeachersPerformanceReportScreen"
    )
);

// Reporte de promedios generales
const AveragesReportsGeneralScreen = lazy(() =>
    import(
        "../../views/operators/averages_reports/AveragesReportsGeneralScreen"
    )
);
// Reporte de tabla generacional
const GenerationalTableScreen = lazy(() =>
    import(
        "../../views/operators/generational_table_report/GenerationalTableScreen"
    )
);

// Reporte de estatus académico
const AcademicStatusReportsScreen = lazy(() =>
    import(
        "../../views/operators/academic_status_reports/AcademicStatusReportsScreen"
    )
);

// Reporte de escuelas de procedencia de estudiantes
const OriginSchoolsReportScreen = lazy(() =>
    import(
        "../../views/operators/origin_school_reports/OriginSchoolReportsScreen"
    )
);

//Reports
const StudentGradesMapReport = lazy(() =>
    import("../../views/students/report/StudentReportGradesMap")
);

const ScheduleToPrint = lazy(() =>
    import("../../components/schedule/ScheduleToPrint")
);

const DiscountScreen = lazy(() =>
    import("../../views/operators/Discount/DiscountScreen")
);

//Listas de distribución
const DistributionListsScreen = lazy(() =>
    import("../../views/operators/distribution_lists/DistributionListsScreen")
);

//Avisos
const NewsScreen = lazy(() => import("../../views/operators/news/NewsScreen"));

//*Aclaraciones
const AclarationsScreen = lazy(() =>
    import("../../views/students/Aclarations/OperatorClarificationScreen")
);

const ReviewDocumentsScreen = lazy(() =>
    import("../../views/operators/reviewDocuments/ReviewDocumentsScreen")
);

const RequestRegistrationScreen = lazy(() =>
    import(
        "../../views/operators/request_registration/RequestRegistrationScreen"
    )
);

const ReviewStatusesScreen = lazy(() =>
    import("../../views/operators/reviewStatus/ReviewStatusScreen")
);

const SocialServiceDetail = lazy(() =>
    import("../../views/students/plans_and_study_programs/SocialServiceDetail")
);
const MarketCashierScreen = lazy(() =>
    import("../../views/operators/marketCashier/MarketCashierScreen")
);
const MarketCashierPayments = lazy(() =>
    import("../../views/operators/marketCashier/MarketCashierPayments")
);
const MassiveUpdateStudentsScreen = lazy(() =>
    import(
        "../../views/operators/massive_updates_students/MassiveUpdateStudentsScreen"
    )
);
const SchoolOfOriginScreen = lazy(() =>
    import("../../views/operators/schools_of_origins/SchoolOfOriginScreen")
);
const MasiveInvoiceScreen = lazy(() =>
    import("../../views/operators/payments/MassiveInvoiceScreen")
);

const GenerateReceiptScreen = lazy(() =>
    import("../../views/operators/payments/GenerateReceiptScreen")
);

const ImportedFiles = lazy(() =>
    import("../../views/operators/payments/ImportedFiles")
);

const InvoiceManualScreen = lazy(() =>
    import("../../views/operators/payments/ManualinvoiceScreen")
);
const ChargeBySubjectScreen = lazy(() =>
    import("../../views/operators/charge_by_subject/ChargeBySubjectScreen")
);
const EndOfMonthScreen = lazy(() =>
    import("../../views/operators/endOfMonth/EndOfMonthScreen")
);
const ServicesByConceptReportScreen = lazy(() =>
    import(
        "../../views/operators/services_by_concept_report/ServicesByConceptReportScreen"
    )
);
const ReviewScholarServicesRequests = lazy(() =>
    import(
        "../../views/operators/review_scholar_services_requests/ReviewScholarServicesRequestsScreen"
    )
);
const PastduePortfolioScreen = lazy(() =>
    import("../../views/operators/Past_due_portfolio/PastduePortfolioScreen")
);
const EducationalCreditsScreen = lazy(() =>
    import("../../views/operators/educational_credits/EducationalCreditsScreen")
);
const EducationalCreditsDetail = lazy(() =>
    import("../../views/operators/educational_credits/EducationalCreditsDetail")
);
const EducationalCreditsContract = lazy(() =>
    import(
        "../../views/operators/educational_credits/EducationalCreditContract"
    )
);
const EducationalCreditsSolicitude = lazy(() =>
    import(
        "../../views/operators/educational_credits/EducationalCreditSolicitude"
    )
);
const EducationalCreditsPromissoryNote = lazy(() =>
    import(
        "../../views/operators/educational_credits/EducationalCreditPromissoryNote"
    )
);
const GraduateGroupsScreen = lazy(() =>
    import("../../views/operators/graduate_groups/GraduateGroupsScreen")
);

// Titulaciones EAD
const GraduationProcessEAD = lazy(() =>
    import(
        "../../views/operators/graduation_process_ead/GraduationProcessEADScreen"
    )
);
const GraduationRequestsScreen = lazy(() =>
    import(
        "../../views/operators/graduation_process_ead/GraduationRequestsScreen"
    )
);
const GraduationRequestsDatesScreen = lazy(() =>
    import(
        "../../views/operators/graduation_process_ead/request_dates/GraduationRequestsDatesScreen"
    )
);

export const UsersRoutes = {
    HomeScreen,
    UserScreen,
    TeacherScreen,
    TeacherDetail,
    TeacherTechnicalSheet,
    CustomerScreen,
    OpportunityScreen,
    OpportunityAdvancesScreen,
    PortfolioScreen,
    PortfolioDetailScreen,
    CustomerDetail,
    TeacherPayroll,
    PayrollScreen,
    CycleScreen,
    TeacherPayrollDetail,
    StudentsScreen,
    StudentsScreenAdmission,
    StudentDetail,
    GenerateXMLScreen,
    OperatorClarificationScreen,
    ProfessionalPracticesScreen,
    ProfessionalPracticesDetail,
    SocialServiceScreen,
    PartnershipsScreen,
    EmployeeScreen,
    EmployeeDetail,
    EmployeeReport,
    DepartmentScreen,
    PunchesScreen,
    AllPunchesScreen,
    SchedulesScreen,
    SchedulesForm,
    ManualsScreen,
    EADScreen,
    JustifyScreen,
    PublicManualScreen,
    FormatScreen,
    PublicFormatScreen,
    CalendarScreen,
    ModulesScreen,
    IncidentsScreen,
    ReportPayrollScreen,
    PastduePortfolioScreen,
    EducationalCreditsScreen,
    EducationalCreditsDetail,
    EducationalCreditsContract,
    EducationalCreditsSolicitude,
    EducationalCreditsPromissoryNote,
    IncidentLog,
    VacationScreen,
    AreaDirectorsScreen,
    TicketsScreen,
    WarehouseScreen,
    TicketsByUser,
    EventScreen,
    ElectronicTitlesScreen,
    CurriculaScreen,
    CurriculaEdit,
    SchoolSubjectScreen,
    CutsPayroll,
    TabulatorScreen,
    ModulesScreenTeacher,
    TeacherPunch,
    ProviderScreen,
    PurchaseScreen,
    BudgetScreen,
    ProfileScreen,
    GroupScreen,
    SettingScreen,
    EnterprisesScreen,
    OrganizationScreen,
    AcademicGroupsScreen,
    DiplomaSchedulesScreen,
    TesisAndUAIsSubjectsScreen,
    ExtracurricularSubjectsScreen,
    AttendanceRoundsScreen,
    AcademicGroupsEdit,
    EarlyInterventionScreen,
    BuildingScreen,
    BuildingEdit,
    ClassroomScreen,
    ClassroomEdit,
    CoordinationScreen,
    CurriculaTabulatorScreen,
    ScholarshipsScreen,
    MoodleBlocksScreen,
    PaymentsScreen,
    ExtraordinariesControlScreen,
    StudentsReport,
    InscriptionSummaryScreen,
    ConventionScreen,
    GraduationProcessEAD,
    PositiveBalanceScreen,
    OrphanInsuranceScreen,
    SchoolControlReportsScreen,
    GradesEditScreen,
    StudentGradesMapReport,
    ScheduleToPrint,
    DiscountScreen,
    DistributionListsScreen,
    NewsScreen,
    AclarationsScreen,
    ReviewDocumentsScreen,
    RequestRegistrationScreen,
    ReviewStatusesScreen,
    SocialServiceDetail,
    MarketCashierScreen,
    MarketCashierPayments,
    GradeUploadReportScreen,
    TeachersByCycleReportScreen,
    DebtsByMonthReportsScreen,
    ScholarshipsReportsScreen,
    GradesBySubjectScreen,
    GradesBySubjectReportScreen,
    DownloadKardexScreen,
    InscriptionsByCycleReportsScreen,
    VehiclePlatesReportsScreen,
    TeachersPerformanceReportScreen,
    AveragesReportsGeneralScreen,
    GenerationalTableScreen,
    AcademicStatusReportsScreen,
    MassiveUpdateStudentsScreen,
    SchoolOfOriginScreen,
    MasiveInvoiceScreen,
    InvoiceManualScreen,
    GenerateReceiptScreen,
    ImportedFiles,
    ChargeBySubjectScreen,
    EndOfMonthScreen,
    ServicesByConceptReportScreen,
    OriginSchoolsReportScreen,
    RolesScreen,
    CycleStudentsReportScreen,
    StudentsByScheduleReportScreen,
    StudentsAttendancesReportScreen,
    TeacherAttendancesReportScreen,
    ClassLoadReportScreen,
    ClassSchedulesReportScreen,
    SubjectHoursReportScreen,
    SubjectsAndPaymentsByStudentsScreen,
    SurveysScreen,
    ExamsScreen,
    AcademicEventsScreen,
    AcademicEventsParticipants,
    ExamApplication,
    SurveyApplication,
    SurveyResultsScreen,
    GraduateGroupsScreen,
    LanguageFollowUpScreen,
    ReviewScholarServicesRequests,
    GraduationRequestsScreen,
    GraduationRequestsDatesScreen,
};
